import * as z from "zod"

export const PermissionModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  account_id: z.number().int().nullish(),
  user_id: z.number().int(),
  /**
   * [TenantId]
   */
  tenant_id: z.string(),
  /**
   * [PermissionLevel]
   */
  role: z.string(),
})
